import Axios from 'axios'
import estadoApp from './estadoApp'
import router from './router'


//Clase donde ejecutamos las peticiones API

// Destino historico exclusivo de npm run serve; Docker utiliza la API relativa.
const URL_BASE_DEV_API = 'https://dev.equinsaparking.com/zd/api';
const URL_BASE_PROD_API = '/api';

class apiZonaDeDescargas {

  constructor() { // Constructor de la clase

    this.instanciaAxios = Axios.create({
      baseURL: (process.env.NODE_ENV !== 'production') ? URL_BASE_DEV_API : URL_BASE_PROD_API,
      timeout: 5000,
      headers: {
        'Content-Type': 'application/json'
        },

    })

    this.instanciaAxios.interceptors.request.use((config) => {
      if (!config.headers.Authorization && localStorage.token) {
        config.headers.Authorization = `Bearer ${localStorage.token}`;
      }

      return config;
    })
    this.instanciaAxios.interceptors.response.use(response => response, error => {
      const response = error.response;
      // No confundir falta de permisos con una sesion que ya no es valida.
      // Una respuesta antigua tampoco debe borrar un login posterior.
      if (response && response.status === 401 && response.data.tipo_error === 'sesion_invalida'
          && error.config.headers.Authorization === `Bearer ${localStorage.token}`) {
        estadoApp.cerrarSesion();
        if (router.currentRoute.path !== '/') router.replace({ path: '/' }).catch(() => {});
      }
      return Promise.reject(error);
    });
  }

  ///Funcion que realiza el login
  login(correo, contrasena) {
    const post = {
      correo: correo,
      contrasena: contrasena
    }
    return new Promise((resolve, reject) => {
      this.instanciaAxios.post('/sesion/iniciar', post)
        .then((resultado) => {
          resolve(resultado)
        }).catch(function (e) {
          reject(e.response)
        })
    })

  }

  ///Funcion que obtiene todos los archivos para descargar
  obtenerArchivosDescargas(hash) {
    return new Promise((resolve, reject) => {
      this.instanciaAxios.get('/descargas?hash='+hash)
        .then((resultado) => {
          resolve(resultado)
        }).catch(function (e) {
          reject(e.response)
        })
    })
  }

  //Obtenemos todos los usuarios
  obtenerUsuarios() {
    return new Promise((resolve, reject) => {
      this.instanciaAxios.get('/usuarios')
        .then((resultado) => {
          resolve(resultado)
        }).catch(function (e) {
          reject(e.response)
        })
    })
  }

  //Eliminamos un usuario, pasado por parametro
  eliminarUsuario(correo) {
    return this.instanciaAxios.delete('/usuarios/' + correo);
  }

  //Obtenemos solo un usuario
  obtenerUsuario(correo) {
    return new Promise((resolve, reject) => {
      this.instanciaAxios.get('/usuarios/' + correo)
        .then((resultado) => {
          resolve(resultado)
        }).catch(function (e) {
          reject(e.response)
        })
    })
  }

  //Editamos el usuario que indica el cliente
  editarUsuario(correo, nombre, contrasena, administrador, bloqueado, id_grupoAccesos,compartirArchivo) {
    const put = {
      correo: correo,
      nombre: nombre,
      contrasena: contrasena,
      administrador: administrador,
      bloqueado: bloqueado,
      id_grupoAccesos: id_grupoAccesos,
      compartirArchivo: compartirArchivo
    }
    return this.instanciaAxios.put('/usuarios/' + correo, put)
  }

  //Se crea un usuario nuevo
  nuevoUsuario(correo, contrasena, nombre, administrador, bloqueado, id_grupoAccesos,compartirArchivo) {
    const post = {
      correo: correo,
      nombre: nombre,
      administrador: administrador,
      bloqueado: bloqueado,
      id_grupoAccesos: id_grupoAccesos,
      contrasena: contrasena,
      compartirArchivo: compartirArchivo
    }
    return new Promise((resolve, reject) => {
      this.instanciaAxios.post('/usuarios', post)
        .then((resultado) => {
          resolve(resultado)
        }).catch(function (e) {
          reject(e.response)
        })
    })
  }

  //Enviamos correo de recuperacion de contraseña al usuario
  envioCorreoRecuperacionContrasena(correo) {
    const post = {
      correo: correo,
    }
    return this.instanciaAxios.post('/recuperarContrasena', post)
  }

  //Establecemos la nueva contraseña a el  usuario indicado
  establecerNuevaContrasena(correo, contrasenaNueva, fecha, hash) {
    const post = {
      correo: correo,
      contrasenaNueva: contrasenaNueva,
      fecha: fecha,
      hash: hash,
    }
    return this.instanciaAxios.post('/establecerNuevaContrasena', post)
  }

  //Esta funcion se encarga de descargar fichero indicado
  descargarFichero(parametroArchivo) {
    return this.instanciaAxios.get('/descargarArchivo?archivo=' + parametroArchivo, { timeout: 0, responseType: 'blob' })
  }

  //Obtenemos los grupos de los accesos de los usuarios
  obtenerGrupoAccesos() {
    return new Promise((resolve, reject) => {
      this.instanciaAxios.get('/gruposAccesosUsuarios')
        .then((resultado) => {
          resolve(resultado)
        }).catch(function (e) {
          reject(e.response)
        })
    })
  }

  //Eliminamos un grupo de acceso, pasado por parametro
  eliminarGrupoAccesos(id) {
    return this.instanciaAxios.delete('/gruposAccesosUsuarios/' + id);
  }

  //Se crea un grupo nuevo de acceso
  nuevoGrupoAccesos(nombre, descripcion, accesos) {
    const post = {
      nombre: nombre,
      descripcion: descripcion,
      accesos: accesos,
    }
    return this.instanciaAxios.post('/gruposAccesosUsuarios', post)
  }

  obtenerUnGrupoDeAcceso(id) {
    return new Promise((resolve, reject) => {
      this.instanciaAxios.get('/gruposAccesosUsuarios/' + id)
        .then((resultado) => {
          resolve(resultado)
        }).catch(function (e) {
          reject(e.response)
        })
    })
  }

  //Edita un grupo de acceso
  editarUnGrupoDeAcceso(id, nombre, descripcion, accesos) {
    const put = {
      id: id,
      nombre: nombre,
      descripcion: descripcion,
      accesos: accesos,
    }
    return this.instanciaAxios.put('/gruposAccesosUsuarios/' + id, put)
  }

  //Obtener todas las carpetas de Primer Nivel
  obtenerCarpetasPrimerNivel() {
    return new Promise((resolve, reject) => {
      this.instanciaAxios.get('/carpetasPrimerNivel')
        .then((resultado) => {
          resolve(resultado)
        }).catch(function (e) {
          reject(e.response)
        })
    })
  }

  //Cerramos sesion
  cerrarSesion() {
    // Capturar el token antes de que el componente borre el estado local.
    return this.instanciaAxios.post('/cerrarSesion', null, {
      headers: { Authorization: `Bearer ${localStorage.token || ''}` }
    });
  }
  //Obtener los sucesos de un usuario
  obtenerSucesosDeUsuario (correo) {
    return new Promise((resolve, reject) => {
      this.instanciaAxios.get('/sucesosUsuario/' + correo)
      .then((resultado) => {
        resolve(resultado)
      }).catch(function (e) {
        reject(e.response)
      })
    })
  }

  //Obtener los sucesos globales
  obtenerSucesosGlobales (dia) {
    return new Promise((resolve, reject) => {
      this.instanciaAxios.get('/sucesosGlobales/'+dia)
      .then((resultado) => {
        resolve(resultado)
      }).catch(function (e) {
        reject(e.response)
      })
    })
  }
  //Funcion para compartir el archivo seleccionado y generar un link para mandarlo por correo
  compartirArchivo (correo, tiempo, archivo,fechaActual) {
    const post = {
      correo: correo,
      tiempo: tiempo,
      archivo: archivo,
      fechaActual:fechaActual
    }
    return new Promise((resolve, reject) => {
      this.instanciaAxios.post('/compartirArchivo', post)
      .then((resultado) => {
        resolve(resultado)
      }).catch(function (e) {
        reject(e.response)
      })
    })
  }

  //Comprobamos la validez del token y lo descarga si es aceptado
  descargarArchivoCompartido (token,nombreFicheroLocal) {

      this.instanciaAxios.get('/descargarArchivoCompartido/' + token, { timeout: 0, responseType: 'blob' })
      .then((resultado) => {
        const blob = new Blob([resultado.data], { type: 'octet/stream' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = nombreFicheroLocal
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(function (e) {
      })

  }

}

export default new apiZonaDeDescargas()
